import React from 'react';
import {observer} from 'mobx-react';
import Loader from '.././common/Loader';
import APIServicesRegistry from '@lib/api-services/APIServicesRegistry';
import store from '@lib/store/SparePartsFinderStore';
import SparePartsFinderProductSerialNumberIndexPage
    from './spare-parts-finder-product-serial-number/SparePartsFinderProductSerialNumberIndexPage';
import SparePartsFinderFiltersIndexPage from './spare-parts-finder-filters/SparePartsFinderFiltersIndexPage';
import SparePartsFinderSOIndexPage from './spare-parts-finder-so/SparePartsFinderSOIndexPage';
import SparePartsFinderPOIndexPage from './spare-parts-finder-po/SparePartsFinderPOIndexPage';

import SparePartsFinderPOApiService from '@lib/api-services/SparePartsFinderPOApiService';
import SparePartsFinderSOApiService from '@lib/api-services/SparePartsFinderSOApiService';
import SparePartsFinderFiltersApiService from '@lib/api-services/SparePartsFinderFiltersApiService';
import SparePartsFinderProductSerialNumberApiService
    from '@lib/api-services/SparePartsFinderProductSerialNumberApiService';

import Dropdown from '../common/DropdownReact';

class SearchType {
    static get ProductSerialNumber() {
        return "Product serial number";
    }

    static get SO() {
        return "SO";
    }

    static get PO() {
        return "PO";
    }

    static get Filters() {
        return "Filters";
    }
}

const page = observer(
    class SparePartsFinderPage extends React.Component {
        state = {
            indexData: null,
            searchType: SearchType.Filters,
            market: this.props.markets.model
        }

        constructor(props) {
            super(props);

            scheduleAtDocumentReady(() => {
                this.sparePartsFinderPOApiService = APIServicesRegistry.getService(SparePartsFinderPOApiService);
                this.sparePartsFinderSOApiService = APIServicesRegistry.getService(SparePartsFinderSOApiService);
                this.sparePartsFinderFiltersApiService = APIServicesRegistry.getService(SparePartsFinderFiltersApiService);
                this.sparePartsFinderProductSerialNumberApiService = APIServicesRegistry.getService(SparePartsFinderProductSerialNumberApiService);
                this.init();
            });
        }

        init() {
            if (this.props.productSerialNumber) {
                this.initSparePartsFinderProductSerialNumber(this.props.productSerialNumber);
            } else {
                this.initSparePartsFinderFilters();
            }
        }

        initSparePartsFinderProductSerialNumber = productSerialNumber => {
            this.sparePartsFinderProductSerialNumberApiService.index(productSerialNumber, this.state.market).then(response => {
                this.setState({
                    indexData: response.data,
                    searchType: SearchType.ProductSerialNumber
                })
            })
        }

        initSparePartsFinderSO = so => {
            this.sparePartsFinderSOApiService.index(so, this.state.market).then(response => {
                this.setState({
                    indexData: response.data,
                    searchType: SearchType.SO
                })
            })
        }

        initSparePartsFinderPO = po => {
            this.sparePartsFinderPOApiService.index(po, this.state.market).then(response => {
                this.setState({
                    indexData: response.data,
                    searchType: SearchType.PO
                })
            })
        }

        initSparePartsFinderFilters = () => {
            this.sparePartsFinderFiltersApiService.index(this.state.market).then(response => {
                this.setState({
                    indexData: response.data,
                    searchType: SearchType.Filters
                })
            })
        }

        render() {
            return (
                <div className="page-body-container page-container">
                    {this.renderHeader()}
                    <div className={this.getBodyClasses()}>
                        <div className="index-filter-panel-contaniner">
                            {this.renderSearchTypes()}
                        </div>
                        <div>
                            {this.renderIndex()}
                        </div>
                    </div>
                </div>
            )
        }

        getBodyClasses = () => {
            let classes = ['body'];
            if (this.state.searchType == SearchType.ProductSerialNumber || this.state.searchType == SearchType.SO || this.state.searchType == SearchType.PO) {
                classes.push('text-search-body');
            }

            return classes.join(' ');
        }

        renderHeader = () => (
            <div className="page-body-titlebar">
                <div className="flex-center-v">
                    <h3 className="page-body-title">{__('Spare parts finder')}</h3>
                    {this.renderMarketDropdown()}
                </div>
            </div>
        )

        renderMarketDropdown = () => {
            var items = this.props.markets.items.map(x => ({
                id: x.value,
                label: x.text
            }));

            var selectedItem = items.find(x => x.id === this.state.market);

            return (
                <React.Fragment>
                    <div className="page-body-title-separator"></div>
                    <div className="mass-export-dropdown">
                        <Dropdown
                            disabled={store.marketDisable}
                            items={items}
                            caption="Market"
                            onItemClick={item => {
                                this.setState({
                                    market: item.id
                                })
                            }}
                            renderCaption={() => (
                                <div className="market-dropdown-caption">
                                    <span>{__('Market')}: </span>
                                    <span>{selectedItem.label}</span>
                                </div>
                            )}
                        />
                    </div>
                </React.Fragment>

            )
        }

        renderIndex() {
            if (!this.state.indexData) {
                return <Loader fillContainer={true}/>
            }

            if (this.state.searchType === SearchType.Filters) {
                return <SparePartsFinderFiltersIndexPage
                    indexApiService={SparePartsFinderFiltersApiService} {...this.getProps()} />
            } else if (this.state.searchType === SearchType.ProductSerialNumber) {
                return <SparePartsFinderProductSerialNumberIndexPage
                    indexApiService={SparePartsFinderProductSerialNumberApiService} {...this.getProps()} />
            } else if (this.state.searchType === SearchType.SO) {
                return <SparePartsFinderSOIndexPage
                    indexApiService={SparePartsFinderSOApiService} {...this.getProps()} />
            } else if (this.state.searchType === SearchType.PO) {
                return <SparePartsFinderPOIndexPage
                    indexApiService={SparePartsFinderPOApiService} {...this.getProps()} />
            }
        }

        renderSearchTypes = () => (
            <ul className="filter-types">
                <li className="label">
                    <div>{__('Search by:')}</div>
                </li>
                {this.renderSearchType(SearchType.ProductSerialNumber)}
                {this.renderSearchType(SearchType.SO)}
                {this.renderSearchType(SearchType.PO)}
                {this.renderSearchType(SearchType.Filters)}
            </ul>
        )

        renderSearchType = searchType => {
            var classNames = [];
            if (this.state.searchType === searchType) {
                classNames.push('selected')
            }

            return <li className={classNames} onClick={() => this.onSearchTypeClick(searchType)}>
                <div>{__(searchType)}</div>
            </li>
        }

        getProps = () => {
            var indexDataFilters = this.state.indexData.filter.viewFilters;
            indexDataFilters.find(x => x.meta.slug === 'Market').model = this.state.market;

            var props = {
                ...this.state.indexData,
                market: this.state.market,
                tableLoadingLoader: false
            }

            return props;
        }

        onSearchTypeClick = searchType => {
            const loadIndexData = () => {
                if (searchType === SearchType.Filters) {
                    this.initSparePartsFinderFilters();
                } else if (searchType === SearchType.ProductSerialNumber) {
                    this.initSparePartsFinderProductSerialNumber('');
                } else if (searchType === SearchType.SO) {
                    this.initSparePartsFinderSO('');
                } else if (searchType === SearchType.PO) {
                    this.initSparePartsFinderPO('');
                }
            }

            this.setState({
                indexData: null
            }, () => {
                loadIndexData();
                store.setMarketDisable(false);
            })
        }
    }
)

window.components.SparePartsFinderPage = page;